module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/archive/archive/consultant-card/consultant-card.component.css
// module id = ./src/app/views/archive/archive/consultant-card/consultant-card.component.css
// module chunks = main